<template>
    <div class="footer">
        <div class="inner">
            <p>以上作品均属香港七星堂版权所有 仿冒必究</p>
            <p>客服热线：400-600-9259 0769-8877-8888</p>
            <p>客户总监：廖先生：177-2716-8169</p>
            <p>电子邮箱：293434203@qq.com</p>
            <p>qixingtang.com © 版权所有 <small>(v1.2)</small></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "sx-footer"
};
</script>

<style scoped>
.footer p {
    margin: 0;
    line-height: 140%;
    color:rgba(0,0,0,.5)
}
</style>